// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getEcommerceProductRequest: ['data'],
  getEcommerceProductSuccess: ['data'],
  getEcommerceProductFailure: ['err'],

  viewEcommerceProductRequest: ['data'],
  viewEcommerceProductSuccess: ['data'],
  viewEcommerceProductFailure: ['err'],

  createEcommerceProductRequest: ['data'],
  createEcommerceProductSuccess: ['data'],
  createEcommerceProductFailure: ['err'],

  createEcommerceProductStockRequest: ['data'],
  createEcommerceProductStockSuccess: ['data'],
  createEcommerceProductStockFailure: ['err'],

  updateEcommerceProductRequest: ['data'],
  updateEcommerceProductSuccess: ['data'],
  updateEcommerceProductFailure: ['err'],

  deleteEcommerceProductRequest: ['data'],
  deleteEcommerceProductSuccess: ['data'],
  deleteEcommerceProductFailure: ['err']

})

export const EcommerceProductTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  data_view: {},
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

export const successView = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_view: data,
    err: null
  })

export const failureView = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err, data_view: {} })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ECOMMERCE_PRODUCT_SUCCESS]: success,
  [Types.GET_ECOMMERCE_PRODUCT_REQUEST]: request,
  [Types.GET_ECOMMERCE_PRODUCT_FAILURE]: failure,

  [Types.VIEW_ECOMMERCE_PRODUCT_SUCCESS]: successView,
  [Types.VIEW_ECOMMERCE_PRODUCT_REQUEST]: request,
  [Types.VIEW_ECOMMERCE_PRODUCT_FAILURE]: failureView,

  [Types.CREATE_ECOMMERCE_PRODUCT_SUCCESS]: success,
  [Types.CREATE_ECOMMERCE_PRODUCT_REQUEST]: request,
  [Types.CREATE_ECOMMERCE_PRODUCT_FAILURE]: failure,

  [Types.CREATE_ECOMMERCE_PRODUCT_STOCK_SUCCESS]: success,
  [Types.CREATE_ECOMMERCE_PRODUCT_STOCK_REQUEST]: request,
  [Types.CREATE_ECOMMERCE_PRODUCT_STOCK_FAILURE]: failure,

  [Types.UPDATE_ECOMMERCE_PRODUCT_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_ECOMMERCE_PRODUCT_REQUEST]: manipulateRequest,
  [Types.UPDATE_ECOMMERCE_PRODUCT_FAILURE]: manipulateFailure,

  [Types.DELETE_ECOMMERCE_PRODUCT_SUCCESS]: manipulateSuccess,
  [Types.DELETE_ECOMMERCE_PRODUCT_REQUEST]: manipulateRequest,
  [Types.DELETE_ECOMMERCE_PRODUCT_FAILURE]: manipulateFailure

})



// WEBPACK FOOTER //
// ./src/Redux/EcommerceProductRedux.js